<template>
  <!-- 机台时序图 -->
  <div class="tab-noOverflow" :style="{ height: height + 'px' }">
    <span :style="{ width: (100 * drawStart).toFixed(2) + '%' }" />
    <span v-for="(item, index) in this.chartData" :key="index"
      :style="{ width: (100 * item.value).toFixed(2) + '%', background: item.color,height: height + 'px'}"/>
  </div>
</template>

<script>
export default {
  name: 'machine-state-line',
  props: {
    width: {
      default: 100
    },
    height: {
      default: 30
    },
    chartData: {
      default: () => []
    },
    drawStart: {
      // 为小数 最大值是1
      default: 0
    }
  },
  filters: {},
  data() {
    return {}
  },
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="scss">
.tab-noOverflow {
  display: flex;
  align-items: center;
  /*不会换行*/
  flex-wrap: nowrap;
  border: 2px solid #999999;
}
</style>
